import React from 'react';
import styles from './ProgressSteps.module.scss';

export interface ProgressStepsProps {
  children: React.ReactNode;
}

export interface ProgressStepProps {
  step?: number;
  title: string;
  active?: boolean;
}

export function ProgressStep({ step, title, active = false }: ProgressStepProps): React.ReactElement {
  return (
    <li className={active ? styles.ProgressActive : ''}>
      <span className={styles.ProgressStep}>{step}</span>
      <span className={styles.ProgressTitle}>{title}</span>
    </li>
  );
}

export function ProgressSteps({ children }: ProgressStepsProps) {
  let actualStepNumber = 0;

  const processedChildren = React.Children.map(children, (child) => {
    // Check if the child is a valid React element and if its type is ProgressStep
    if (React.isValidElement(child) && child.type === ProgressStep) {
      actualStepNumber++;

      // Clone the ProgressStep element and inject the new 'step' prop.
      // Other props like 'title' and 'active' from the original child are preserved.
      return React.cloneElement(
        child as React.ReactElement<ProgressStepProps>, // Cast to ensure TS knows about original props
        {
          step: actualStepNumber,
        }
      );
    }

    // Return other children (like null from conditional rendering, or other element types) as is
    return child;
  });

  return <ol className={styles.ProgressSteps}>{processedChildren}</ol>;
}
